import "./App.css";
import { Fragment } from "react";
import { Filter } from "./filter";
import React from "react";
import data from "./data.json";

function App() {
  var _filterVer = 1;
  var [filterVer, setFilterVer] = React.useState(1);
  var [filter, setFilter] = React.useState([]);

  var filters = [
    {
      id: "1",
      title:
        "1. Крош решил, что ему пора начать получать доходы, но он пока не знает, что это такое. Помоги Крошу разобраться, что такое доходы:",
      oneVal: true,
      img: "assets/images/quiz/img_2.jpg",
      vals: [
        "продукты, которые покупают в магазине;",
        "деньги, которые получает человек или Смешарик;",
        "место, до которого можно дойти пешком.",
      ],
    },
    {
      id: "2",
      title:
        "2. Копатыч изучает финансовую грамотность и обратился к нам за помощью. Что из перечисленного относится к его доходам?",
      oneVal: true,
      img: "assets/images/quiz/img_3.jpg",
      vals: ["покупка удобрений для огорода;", "покупка новой удочки для рыбалки;", "хороший урожай меда с пасеки."],
    },
    {
      id: "3",
      title: "3. Лосяш хочет сравнить свои доходы и расходы. Что из списка Лосяша относится к расходам?",
      oneVal: true,
      img: "assets/images/quiz/img_1.jpg",
      vals: [
        "морковка, которой Лосяша угостил Крош;",
        "новый телескоп, который купил Лосяш;",
        "Нобелевская премия, которую вручили Лосяшу.",
      ],
    },
    {
      id: "4",
      title:
        "4. Бараш хочет понять, сможет ли он накопить на подарок Нюше. Для этого он составляет план своих доходов и расходов. Как называется такой план?",
      oneVal: true,
      img: "assets/images/quiz/img_4.jpg",
      vals: ["бюджет;", "билет;", "банкет."],
    },
    {
      id: "5",
      title: "5. Лосяш перевёл Карычу деньги на карту. Что это за карта?",
      oneVal: true,
      img: "assets/images/quiz/img_5.jpg",
      vals: ["карта Ромашковой долины;", "медицинская карта;", "банковская карта."],
    },
    {
      id: "6",
      title: "6. Пин хочет защитить свои накопления. Как правильно это сделать?",
      oneVal: true,
      img: "assets/images/quiz/img_6.jpg",
      vals: ["положить в банк;", "спрятать под подушку;", "потратить поскорее."],
    },
    {
      id: "7",
      title:
        "7. Ёжик приобрел страховку от спортивных травм и поехал вместе с Крошем кататься на лыжах. Во время поездки обошлось без происшествий: все вернулись целыми и невредимыми. Чего ждать Ёжику от страховой компании?",
      oneVal: true,
      img: "assets/images/quiz/img_12.jpg",
      vals: [
        "выплаты премии за аккуратное катание;",
        "возврата стоимости страховки, ведь он не получил травм;",
        "раз травм не произошло, страховая компания ничего не должна платить.",
      ],
    },
    {
      id: "8",
      title: "8. Крош пришел в магазин и совершил несколько ошибок. Какая из ошибок не является финансовой?",
      oneVal: true,
      img: "assets/images/quiz/img_7.jpg",
      vals: [
        "Крош не поздоровался с продавцом;",
        "Крош купил ненужные ему вещи;",
        "Крош не составил заранее список покупок и ему не хватило денег на действительно необходимое.",
      ],
    },
    {
      id: "9",
      title:
        "9. Продолжаем помогать Копатычу изучать финансовую грамотность. Что такое «финансовая подушка безопасности»?",
      oneVal: true,
      img: "assets/images/quiz/img_8.jpg",
      vals: [
        "деньги, которые берут в долг;",
        "деньги, которые тратят в магазине;",
        "деньги, которые откладывают «на черный день».",
      ],
    },
    {
      id: "10",
      title:
        "10. Совунье позвонили из службы безопасности банка и сказали, что кто-то хочет снять все деньги с её банковской карты.  Чтобы остановить мошенников, сотрудник банка попросил сообщить пин-код. Как должна поступить Совунья?",
      oneVal: true,
      img: "assets/images/quiz/img_9.jpg",
      vals: [
        "продиктовать пин-код своей карты;",
        "прислать пин-код своей карты по электронной почте;",
        "положить трубку и перезвонить в банк по телефону, указанному на карте. ",
      ],
    },
    {
      id: "11",
      title:
        "11. Нюша взяла в банке кредит на покупку нового платья. Сотрудник банка рассказал, что кредит нужно «обслуживать» каждый месяц. Что придётся делать Нюше?",
      oneVal: true,
      img: "assets/images/quiz/img_10.jpg",
      vals: [
        "приносить сотрудникам банка подарки в благодарность за выданный кредит;",
        "тратить деньги как можно быстрее;",
        "возвращать банку деньги, как прописано в договоре, – и отдать больше, чем стоило платье. ",
      ],
    },
    {
      id: "12",
      title:
        "12. Лосяш знает, что такое обязательные и необязательные расходы. Обязательные – это то, без чего нельзя обойтись. Например, покупка еды или плата за отопление. А необязательные – то, без чего вполне можно обойтись. Отметь НЕобязательные расходы в бюджете Лосяша:",
      oneVal: true,
      img: "assets/images/quiz/img_11.jpg",
      vals: [
        "покупка молока и крупы, чтобы варить кашу на завтрак;",
        "траты на бензин, чтобы добраться до работы;",
        "расходы на билеты в кино и попкорн перед сеансом.",
      ],
    },
  ];

  const onFilter = (e) => {
    console.log("Filter event");
    console.log(JSON.stringify(e.detail.filter));
    setFilter(e.detail.filter);
    _filterVer++;
    setFilterVer(_filterVer);
  };

  if (window.onFilter) document.removeEventListener("Filter", window.onFilter);
  window.onFilter = onFilter;
  document.addEventListener("Filter", window.onFilter);

  return (
    <Fragment>
      <section id="filter_section" className="pt-60 pb-100">
        <div className="container">
          <div className="row justify-content-center pb-20">
            <div className="text-center">
              <h1></h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <Filter filters={filters}></Filter>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default App;
